class ProductSwym extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.checkIsInWishlist(Number(this.els.trigger.element.dataset.productId))
  }

  setupListeners () {
    super.setupListeners()

    this.handleWishlistButton = this.handleWishlistButton.bind(this)
    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.handleWishlistButton,
    )
  }

  handleWishlistButton () {
    if (!window._swat) return

    const data = {
      epi: Number(this.els.trigger.element.dataset.variantId),
      du: `${this.els.trigger.element.dataset.productUrl}`,
      empi: Number(this.els.trigger.element.dataset.productId),
    }

    if (
      this.els.trigger.element.getAttribute('data-wishlist-status') === 'added'
    ) {
      window._swat.removeFromWishList(data, () => {
        this.els.trigger.element.setAttribute(
          'data-wishlist-status',
          'not-added',
        )
      })
    } else {
      window._swat.addToWishList(data, () => {
        this.els.trigger.element.setAttribute('data-wishlist-status', 'added')
      })
    }
  }

  checkIsInWishlist (productId) {
    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push(swat => {
      swat.fetchWrtEventTypeET(products => {
        const matchedProduct = products.find(
          product => product.empi === productId,
        )

        if (matchedProduct) {
          this.els.trigger.element.setAttribute('data-wishlist-status', 'added')
        } else {
          this.els.trigger.element.setAttribute(
            'data-wishlist-status',
            'not-added',
          )
        }
      }, 4)
    })
  }
}

if (!customElements.get('product-swym')) {
  customElements.define('product-swym', ProductSwym)
}
